import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getSelected } from 'helpers/listHelpers';
import ApprovalListControls from 'components/common/controls/approvals/ApprovalListControls';
import ApprovalButtons from 'components/common/controls/approvals/ApprovalButtons';
import List from './List';

export default class ApprovalList extends Component {
    static propTypes = {
        route: PropTypes.object.isRequired,
        meta: PropTypes.object.isRequired,
        items: PropTypes.array.isRequired,
        counters: PropTypes.object,
        status: PropTypes.object,
        selected: PropTypes.array,
        sort: PropTypes.object,
        sortFields: PropTypes.array.isRequired,

        getList: PropTypes.object.isRequired,
        getCounters: PropTypes.object.isRequired,

        setSort: PropTypes.func.isRequired,
        setSelected: PropTypes.func.isRequired,
        setPagination: PropTypes.func,

        openModalApprove: PropTypes.func,
        openModalReject: PropTypes.func,
        openModalCancel: PropTypes.func,

        buttons: PropTypes.object
    };

    renderControls = ({ handleRefresh }) => {
        const { getList: { meta }, getCounters: { data } } = this.props;
        const { items, selected, sort, sortFields, setSort, route, buttons, status } = this.props;
        const { openModalApprove, openModalReject, openModalCancel } = this.props;

        return (
            <div className="list-controls">
                <div className="table-first-controls">
                    <ApprovalButtons
                        selected={selected}
                        buttons={buttons}
                        filters={status}
                        cancel={openModalCancel && (() => openModalCancel(getSelected(selected, items))) }
                        approve={openModalApprove && (() => openModalApprove(getSelected(selected, items))) }
                        reject={openModalReject && (() => openModalReject(getSelected(selected, items))) }
                    />
                </div>
                <ApprovalListControls
                    counters={data}
                    route={route}
                    sort={sort}
                    sortFields={sortFields}
                    setSort={setSort}
                    handleRefresh={handleRefresh}
                    refreshMeta={meta}
                />
            </div>
        );
    }

    render() {
        return (
            <List
                {...this.props}
                className='width-auto-table approval-table'
                controls={this.renderControls}
            />
        );
    }
}
